import classNames from 'classnames';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { OrganizationConfigContext } from '../../context/OrganizationConfigContext';
import styles from './LinkList.module.scss';

export const LinkList = () => {
  const { t } = useTranslation();
  const { cloudLicense, cloudLink } = useContext(OrganizationConfigContext);

  const canNextcloud = cloudLicense && cloudLink;

  return (
    <div className={styles['link-list']}>
      <NavLink
        to={canNextcloud ? `https://${cloudLink}` : ''}
        className={classNames(styles.link, {
          [styles.disabled]: !canNextcloud,
        })}
        target='_blank'
      >
        {canNextcloud ? t('common.nextcloud') : `${t('common.nextcloud')} (${t('links.notAvailable')})`}
      </NavLink>
    </div>
  );
};
